// src/components/configuration/sections/legal/legal-configuration-display.component.jsx

import { useEffect, useState } from 'react';

import AgeVerifyConfigurationDisplay from './age-verify/age-verify-configuration-display.component';
import Spinner from '../../../reusable/spinner/spinner.component';

import Client from '../../../../tools/client';

import {
  Container,
  FieldSection,
  SectionTitle
} from '../configuration-sections.styles';

const client = new Client();

const LegalConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({});

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    setLoading(true);
    const res = await client.setup();
    const legal = res.configuration?.legal || {};
    setConfig(legal);
    setLoading(false);
  };

  if (loading) return <Spinner />;

  return (
    <Container>
      <FieldSection>
        <SectionTitle>Age Verification</SectionTitle>
        <AgeVerifyConfigurationDisplay config={config.ageVerify || {}} />
      </FieldSection>
    </Container>
  );
};

export default LegalConfigurationDisplay;